export const zipRegEx = /^\d{5}$/

// regex finds commas, semicolons, carriage returns & spaces within the string
export const multiZipRegEx = /\s*[;,:\r\n\s+]+\s*/g

// regex finds commas, semicolons, spaces at the beginning or end of the string
export const beRegEx = /^[\s+,;:]+|[\s+,;:]+$/g
export const maxZipCodes = 100
